@if (showTourButton) {
  @if (styleButton() === 'icon') {
    <button
      (click)="startInteractiveTour()"
      [ngClass]="getClass()"
      color="primary"
      mat-icon-button
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="
        disabledTourButton
          ? ('igo.common.interactiveTour.disaledTooltipTourToolButton'
            | translate)
          : ('igo.common.interactiveTour.tooltipTourToolButton' | translate)
      "
      [disabled]="disabledTourButton"
    >
      <igo-icon [icon]="presentationIcon" iconPositionEnd />
    </button>
  } @else {
    <button
      (click)="startInteractiveTour()"
      [ngClass]="getClass()"
      color="primary"
      matButton="elevated"
      tooltip-position="below"
      matTooltipShowDelay="500"
      [disabled]="disabledTourButton"
    >
      {{ 'igo.common.interactiveTour.buttonTitle' | translate }}
      {{ discoverTitleInLocale$() | async | translate }}
      <mat-icon
        [svgIcon]="presentationIcon.name"
        iconPositionEnd
        [matTooltip]="
          disabledTourButton
            ? ('igo.common.interactiveTour.disaledTooltipTourToolButton'
              | translate)
            : ('igo.common.interactiveTour.tooltipTourToolButton' | translate)
        "
      />
    </button>
  }
}
